export default __webpack_public_path__ + "static/media/Parallax3.b7ed7295.jpg";